import { AlfaApiLoanApplicationStatuses } from '@/modules/alfa-api-loan-application-statuses/types';

export namespace AlfaApiLoanApplications {
  export enum Pages {
    ALFA_API_LOAN_APPLICATIONS = 'alfa-api-loan-applications',
  }

  export interface AlfaApiLoanApplication {
    id: number;
    order_id: number;
    deal_id: string;
    borrower_inn: string;
    borrower_ogrn: string;
    borrower_kpp: string | null;
    borrower_contact_phone: string;
    partner_order_number: string;
    partner_order_date: string;
    partner_order_amount: string;
    partner_payment_transfer_type: string;
    partner_payment_vat: boolean;
    partner_payment_vat_amount: string;
    partner_payment_bank_name: string;
    partner_payment_bank_bic: string;
    partner_payment_bank_correspondent_account: string;
    partner_recipient_inn: string;
    partner_recipient_kpp: string | null;
    partner_recipient_account: string;
    partner_recipient_name: string;
    created_at: string;
    updated_at: string;
    alfa_api_loan_application_status_id: number;
    alfa_api_loan_application_status: AlfaApiLoanApplicationStatuses.AlfaApiLoanApplicationStatus | undefined;
    redirect_url: string;
  }

  export interface AlfaApiLoanApplicationIndexFilters {
    organizationIds: number[];
    statusIds: number[];
    orderIds: number[];
    createdDateRange: string[];
    orderDateRange: string[];
  }
}
